/**
 * Copyright © 2026 Indisea Software LLC. All rights reserved.
 *
 * Proprietary and confidential. Licensed, not sold. Use is subject to the
 * license agreement between Indisea Software LLC and the licensee.
 * See LICENSE for full terms.
 *
 * SPDX-License-Identifier: LicenseRef-Indisea-Proprietary
 */

import { createTheme } from '@mui/material/styles';

const fontBody = '"Season Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif';
const fontHeadline = '"Season Mix", Georgia, "Times New Roman", serif';

const theme = createTheme({
    palette: {
        primary: {
            main: '#183e3d',
            dark: '#2a5f5d',
            light: '#2a5f5d',
            contrastText: '#ffffff',
        },
        secondary: {
            main: '#ff8232',
        },
    },
    typography: {
        fontFamily: fontBody,
        h1: { fontFamily: fontHeadline, letterSpacing: '-0.02em', lineHeight: 1.2 },
        h2: { fontFamily: fontHeadline, letterSpacing: '-0.02em', lineHeight: 1.2 },
        h3: { fontFamily: fontHeadline, letterSpacing: '-0.02em', lineHeight: 1.2 },
        h4: { fontFamily: fontHeadline, letterSpacing: '-0.02em', lineHeight: 1.2 },
        h5: { fontFamily: fontHeadline, letterSpacing: '-0.02em', lineHeight: 1.2 },
        h6: { fontFamily: fontHeadline, letterSpacing: '-0.02em', lineHeight: 1.2 },
        subtitle1: { fontFamily: fontHeadline, letterSpacing: '-0.02em', lineHeight: 1.2 },
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    fontFamily: fontBody,
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                containedPrimary: {
                    '&:hover': {
                        backgroundColor: '#2a5f5d',
                    },
                },
            },
        },
        MuiFormHelperText: {
            styleOverrides: {
                root: {
                    fontFamily: fontBody,
                },
            },
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    fontFamily: fontBody,
                },
            },
        },
        MuiFormLabel: {
            styleOverrides: {
                root: {
                    fontFamily: fontBody,
                },
            },
        },
        MuiInputBase: {
            styleOverrides: {
                root: {
                    fontFamily: fontBody,
                },
                input: {
                    fontFamily: fontBody,
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    fontFamily: fontBody,
                },
                input: {
                    fontFamily: fontBody,
                },
            },
        },
        MuiAlert: {
            styleOverrides: {
                root: {
                    fontFamily: fontBody,
                },
                message: {
                    fontFamily: fontBody,
                },
            },
        },
        MuiDialogTitle: {
            styleOverrides: {
                root: {
                    fontFamily: fontHeadline,
                    letterSpacing: '-0.02em',
                },
            },
        },
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    fontFamily: fontBody,
                },
            },
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    fontFamily: fontBody,
                },
            },
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    fontFamily: fontBody,
                },
            },
        },
        MuiTab: {
            styleOverrides: {
                root: {
                    fontFamily: fontBody,
                },
            },
        },
        MuiChip: {
            styleOverrides: {
                label: {
                    fontFamily: fontBody,
                },
            },
        },
        MuiAutocomplete: {
            styleOverrides: {
                option: {
                    fontFamily: fontBody,
                },
            },
        },
    },
});

export default theme;
